import { isShape, metrics } from './editorCatalog';
import { objectBounds } from './ObjectArtwork';
import { measuredText } from './textMetrics';

// Real print size in cm (stroke widths stay in mm elsewhere).
export const dimsCm = o => {
  if (isShape(o)) return { w: o.widthMm / 10, h: o.type === 'line' ? 0 : o.heightMm / 10 };
  const b = o.type === 'text' ? measuredText(o) : objectBounds(o), k = (o.scale || 1) / metrics.unitsPerMm / 10;
  return { w: b.w * k, h: b.h * k, perScale: b.w / metrics.unitsPerMm / 10 };
};
export const cm = v => v.toFixed(1).replace('.', ',');
export const sizeValue = o => { const d = dimsCm(o); return o.type === 'line' ? `${cm(d.w)} cm` : `${cm(d.w)} × ${cm(d.h)} cm`; };
